import { useFiltersCtxStore } from '../../store';
import { FilterDropdownWrapper } from './FilterDropdownWrapper';

export const BaseFilter = ({
  filterConfig,
  isInline,
  filterOnChangeHandler,
  arrowConfig,
  dataRole,
  controlWrapperClassName
}) => {
  const currentFilterData = useFiltersCtxStore('currentFilterData');
  const appliedFilterData = useFiltersCtxStore('appliedFilterData');

  return filterConfig.map(
    ({
      label,
      key,
      options,
      disabled = false,
      Component,
      selectClassName,
      automationTestsClassName
    }) => (
      <FilterDropdownWrapper
        key={`filter-${key}`}
        isInline={isInline}
        arrowConfig={arrowConfig}
        filterKey={key}
        label={label}
        value={
          currentFilterData[key]
            ? currentFilterData[key]
            : appliedFilterData[key]
        }
        currentFilterData={currentFilterData}
        disabled={disabled}
        options={options}
        onChange={(value) => filterOnChangeHandler(key, value)}
        dataRole={dataRole || automationTestsClassName}
        Component={Component}
        selectClassName={selectClassName}
        wrapperClassName={controlWrapperClassName}
      />
    )
  );
};
